import { createSlice } from '@reduxjs/toolkit';
import { SWISSCODE } from '../../services/service';
import { DEBUG } from '../../services/domainService';

/** @typedef {{configurationID: string | null,ruleset_id: string | null,form: string | null,installation: string | null,configurationLineLengths: number[] | null,color:  string | null,protection:  string | null,diffusor:  string | null,power:  string | null,configurationProductPriceEur: number | null,configurationProductPriceChf: number | null,configurationProducts: any | null,countryCode: string | null,startingRotation: 0,projectName: string | null,projectAuthor: string | null,pureliteSlimLighting: import('../../services/service').LightingDirection,configurationPendelLength: 1500,feedPointPosition: 'start',projectBuilding: string | null,projectFloor: string | null,projectRoom: string | null,projectLine: string | null,addWiring: false,useEmergency: false}} Configuration */
/**  @type {Configuration} */
const initialState = {
    configurationID: null,
    ruleset_id: null,
    form: null,
    installation: null,
    configurationLineLengths: null,
    color: null,
    protection: null,
    diffusor: null,
    power: null,
    configurationProductPriceEur: null,
    configurationProductPriceChf: null,
    configurationProducts: null,
    countryCode: null,
    startingRotation: 0,
    projectName: null,
    projectAuthor: null,
    pureliteSlimLighting: null,
    configurationPendelLength: 1500,
    feedPointPosition: 'start',
    projectBuilding: null,
    projectFloor: null,
    projectRoom: null,
    projectLine: null,
    addWiring: false,
    useEmergency: false,
};

export const configurationSlice = createSlice({
    name: 'configuration',
    initialState,
    reducers: {
        setConfigurationID: (state, action) => {
            state.configurationID = action.payload;
        },
        setRulesetID: (state, action) => {
            state.ruleset_id = action.payload;
        },
        setForm: (state, action) => {
            state.form = action.payload;
        },
        setInstallation: (state, action) => {
            state.installation = action.payload;
        },
        setConfigurationLineLengths: (state, action) => {
            state.configurationLineLengths = action.payload;
        },
        setConfigurationColor: (state, action) => {
            state.color = action.payload;
        },
        setConfigurationProtection: (state, action) => {
            state.protection = action.payload;
        },
        setConfigurationDiffusor: (state, action) => {
            state.diffusor = action.payload;
        },
        setConfigurationPower: (state, action) => {
            state.power = action.payload;
        },
        setConfigurationProductPriceEur: (state, action) => {
            state.configurationProductPriceEur = action.payload;
        },
        setConfigurationProductPriceChf: (state, action) => {
            state.configurationProductPriceChf = action.payload;
        },
        setConfigurationProducts: (state, action) => {
            state.configurationProducts = action.payload;
        },
        setCountryCode: (state, action) => {
            // state.countryCode = "DE"; // TODO: This is only done to make the server run for now because there is a bug related to the Swiss style
            state.countryCode = action.payload;
        },
        setStartingRotation: (state, action) => {
            state.startingRotation = action.payload;
        },
        setProjectName: (state, action) => {
            state.projectName = action.payload;
        },
        setProjectAuthor: (state, action) => {
            state.projectAuthor = action.payload;
        },
        setPureliteSlimLighting: (state, action) => {
            state.pureliteSlimLighting = action.payload;
        },
        setConfigurationPendelLength: (state, action) => {
            state.configurationPendelLength = action.payload;
        },
        setFeedPointPosition: (state, action) => {
            state.feedPointPosition = action.payload;
        },
        setProjectBuilding: (state, action) => {
            state.projectBuilding = action.payload;
        },
        setProjectFloor: (state, action) => {
            state.projectFloor = action.payload;
        },
        setProjectRoom: (state, action) => {
            state.projectRoom = action.payload;
        },
        setProjectLine: (state, action) => {
            state.projectLine = action.payload;
        },
        setAddWiring: (state, action) => {
            state.addWiring = action.payload;
        },
        setEmergency: (state, action) => {
            state.useEmergency = action.payload;
        },
        resetConfiguration: () => initialState,
    },
});

export const {
    setConfigurationID,
    setRulesetID,
    setForm,
    setInstallation,
    setConfigurationLineLengths,
    setConfigurationColor,
    setConfigurationProtection,
    setConfigurationDiffusor,
    setConfigurationPower,
    setConfigurationProductPriceEur,
    setConfigurationProductPriceChf,
    setConfigurationProducts,
    resetConfiguration,
    setCountryCode,
    setStartingRotation,
    setProjectAuthor,
    setProjectName,
    setPureliteSlimLighting,
    setConfigurationPendelLength,
    setFeedPointPosition,
    setProjectLine,
    setProjectFloor,
    setProjectBuilding,
    setProjectRoom,
    setAddWiring,
    setEmergency,
} = configurationSlice.actions;

export const selectConfigurationID = (/** @type {{ configuration: Configuration; }} */ state) => state.configuration.configurationID;
export const selectRulesetID = (/** @type {{ configuration: Configuration; }} */ state) => state.configuration.ruleset_id;
export const selectForm = (/** @type {{ configuration: Configuration; }} */ state) => state.configuration.form;
export const selectInstallation = (/** @type {{ configuration: Configuration; }} */ state) => state.configuration.installation;
export const selectConfigurationLineLengths = (/** @type {{ configuration: Configuration; }} */ state) => state.configuration.configurationLineLengths;
export const selectConfigurationColor = (/** @type {{ configuration: Configuration; }} */ state) => state.configuration.color;
export const selectConfigurationProtection = (/** @type {{ configuration: Configuration; }} */ state) => state.configuration.protection;
export const selectConfigurationDiffusor = (/** @type {{ configuration: Configuration; }} */ state) => state.configuration.diffusor;
export const selectConfigurationPower = (/** @type {{ configuration: Configuration; }} */ state) => state.configuration.power;
export const selectConfigurationProductPriceEur = (/** @type {{ configuration: Configuration; }} */ state) => state.configuration.configurationProductPriceEur;
export const selectConfigurationProductPriceChf = (/** @type {{ configuration: Configuration; }} */ state) => state.configuration.configurationProductPriceChf;
export const selectConfigurationProducts = (/** @type {{ configuration: Configuration; }} */ state) => state.configuration.configurationProducts;
export const selectCountryCode = (/** @type {{ configuration: Configuration; }} */ state) => (DEBUG ? SWISSCODE : state.configuration.countryCode);
export const selectStartingRotation = (/** @type {{ configuration: Configuration; }} */ state) => state.configuration.startingRotation;
export const selectProjectName = (/** @type {{ configuration: Configuration; }} */ state) => state.configuration.projectName;
export const selectProjectAuthor = (/** @type {{ configuration: Configuration; }} */ state) => state.configuration.projectAuthor;
export const selectLightDirection = (/** @type {{ configuration: Configuration; }} */ state) => state.configuration.pureliteSlimLighting;
export const selectConfigurationPendelLength = (/** @type {{ configuration: Configuration; }} */ state) => state.configuration.configurationPendelLength;
export const selectFeedPointPosition = (/** @type {{ configuration: Configuration; }} */ state) => state.configuration.feedPointPosition;
export const selectProjectBuilding = (/** @type {{ configuration: Configuration; }} */ state) => state.configuration.projectBuilding;
export const selectProjectFloor = (/** @type {{ configuration: Configuration; }} */ state) => state.configuration.projectFloor;
export const selectProjectRoom = (/** @type {{ configuration: Configuration; }} */ state) => state.configuration.projectRoom;
export const selectProjectLine = (/** @type {{ configuration: Configuration; }} */ state) => state.configuration.projectLine;
export const selectAddWiring = (/** @type {{ configuration: Configuration; }} */ state) => state.configuration.addWiring;
export const selectUseEmergency = (/** @type {{ configuration: Configuration; }} */ state) => state.configuration.useEmergency;

export default configurationSlice.reducer;
